<template>
  <div class="offcn-teacher-launch">
    <div class="launch-content">
      <div class="left">
        <img class="left-img" src="./img/left.png">
      </div>
      <div class="right-content">
        <div class="brand">
          <img src="./img/logo.png">
          <span>中公直播</span>
        </div>
        <div class="guide">
          <div class="guide-title">第一次使用新版客户端？</div>
          <div class="guide-process">
            <span class="step1">
              <i>1</i>
              <a @click="downclient">下载最新版直播客户端</a>
            </span>
            <img src="./img/arrow-right.svg">
            <span>
              <i>2</i>
              安装
            </span>
            <img src="./img/arrow-right.svg">
            <span>
              <i>3</i>
              回到网页点击进入直播间
            </span>
          </div>
        </div>
        <div class="manual-launch">
          <div class="manual-launch-title">
            已安装新版客户端，直播间没有自动打开？
          </div>
          <div class="manual-launch-button">
            <button @click="openclientbyClick(1)">手动进入直播间</button>
            <button class="old" @click="openclientbyClick(2)">旧版中公直播</button>
            <button class="old" @click="openclientbyClick(3)">旧版中公互动</button>
          </div>
        </div>
        <div class="recommend-browsers">
          推荐使用：
          <img src="./img/google.svg">
          Google Chrome浏览器
          <span>/</span>
          <img src="./img/firefox.svg">
          Firefox火狐浏览器
        </div>
      </div>
      <p class="service-tel">使用过程遇到问题，可联系客服400-900-8885</p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
  	openclient () {
      let requestStr = this.GetRequestStr()
      // var isopen = window.open('zgLiveMc://' + requestStr)
      // if (isopen) {
      //   isopen.close()
      // }
      if (navigator.userAgent.indexOf('Firefox') > -1) {
        var isopen = window.open('offcnlive://' + requestStr)
        if (isopen) {
          isopen.close()
        }
      } else {
        window.location.href = 'offcnlive://' + requestStr
      }
    },
    openclientbyClick (flag) {
      let requestStr = this.GetRequestStr()
      if (flag === 1) {
        window.location.href = 'offcnlive://' + requestStr
      } else if (flag === 2) {
        requestStr = requestStr.substring(1)
        console.log('zglive://' + requestStr)
        window.location.href = 'zglive://' + requestStr
      } else if (flag === 3) {
        console.log('zgLiveMc://' + requestStr)
        window.location.href = 'zgLiveMc://' + requestStr
      }
    },
    isMac () {
      return /macintosh|mac os x/i.test(navigator.userAgent)
    },
  	downclient () {
      var isMac = (function () {
        return /macintosh|mac os x/i.test(navigator.userAgent)
      }())
      let currentUrl = location.href
      console.log(currentUrl)
      if (isMac) {
        if (currentUrl.indexOf('//teacher.offcncloud.com') > -1) {
          window.location.href = 'https://desktop.offcncloud.com/offcnLiveUpdate/offcnLive/mac/offlinePackage/ZgLiveSetup.pkg'
        } else {
          window.location.href = 'https://desktop.offcncloud.com/offcnLiveUpdate/offcnLive/test/mac/offlinePackage/ZgLiveSetup.pkg'
        }
      } else {
        if (currentUrl.indexOf('//teacher.offcncloud.com') > -1) {
          window.open('https://desktop.offcncloud.com/offcnLiveUpdate/offcnLive/windows/offlinePackage/ZgLiveSetup.exe')
        } else {
          window.open('https://desktop.offcncloud.com/offcnLiveUpdate/offcnLive/test/windows/offlinePackage/ZgLiveSetup.exe')
        }
      }
    },
    // 获取url后参数
    GetRequest () {
      var url = location.hash // 获取url中"?"符后的字串
      var theRequest = {}
      if (url.indexOf('?') !== -1) {
        var str = url.substr(url.indexOf('?') + 1)
        var strs
        strs = str.split('&')
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
        }
      }
      return theRequest
    },
    GetRequestStr () {
      let hashStr = location.hash
      return hashStr.substr(hashStr.indexOf('?'))
    }
  },
  mounted () {
  	if (!this.$route.query.nickname) {
  		this.$router.push({path: 'loginrtc', query: this.$route.query})
    }
    if (this.$route.query.nickname && this.$route.query.password) {
      // if (!this.isMac()) {
      //   this.openclient()
      // }
      this.openclient()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.offcn-teacher-launch
{
	width: 100%;
  background: #fafafa;
  min-height: 100%;
  position: relative;
  .launch-content{
    position: absolute;
    width: 800px;
    height: 450px;
    background: #ffffff;
    left: 50%;
    top: 50%;
    margin-left: -400px;
    margin-top: -230px;
    box-shadow: -1.7px -2.5px 40px 0px rgba(230, 230, 230, 0.4);
	  border-radius: 4px;
    .left{
      float: left;
      width: 330px;
      height: 450px;
      img.left-img{
        font-size: 0;
        width: 330px;
        height: 450px;
      }
    }
    .right-content{
      margin-left: 30px;
      float: left;
      .brand{
        padding-top: 30px;
        overflow: hidden;
        img{
          font-size: 0;
          float: left;
          margin-right: 10px;
          width: 37px;
          height: 37px;
        }
        span{
          float: left;
          height: 37px;
          line-height: 37px;
          font-size: 22px;
          color: #0d152d;
          font-weight: bold;
        }
      }
      .guide{
        margin-top: 40px;
        width: 411px;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
        .guide-title{
          font-size: 16px;
          color: #0d152d;
          font-weight: bold;
        }
        .guide-process{
          margin-top: 20px;
          span{
            font-size: 12px;
            color: #0d152d;
            i{
              display: inline-block;
              width: 16px;
              height: 16px;
              background-color: #fe895f;
              border-radius: 4px;
              color: #ffffff;
              font-size: 12px;
              font-style: normal;
              text-align: center;
              line-height: 16px;
              margin-right: 2px;
            }
            a{
              cursor: pointer;
              color: #ff895f;
              text-decoration: underline;
            }
          }
          img{
            width: 10px;
            height: 9px;
            margin: 0 7px;
          }
        }
      }
      .manual-launch{
        margin-top: 20px;
        .manual-launch-title{
          font-size: 16px;
          color: #0d152d;
          font-weight: bold;
          margin-bottom: 19px;
        }
        .manual-launch-button{
          button{
            width: 141px;
            height: 41px;
            background-color: #fe895f;
	          border-radius: 4px;
            border:0;
            font-size: 14px;
            color: #ffffff;
            cursor: pointer;
            outline: none;
            margin-right: 5px;
            &.old{
              border: solid 1px #e5e5e5;
              background-color: #ffffff;
              color: #949bab;
              width: 120px;
            }
          }
        }
      }
      .recommend-browsers{
        margin-top: 137px;
        font-size: 12px;
        color: #949bab;
        img {
          width: 16px;
          height: 16px;
          position: relative;
          top: 3px;
        }
        span{
          padding: 0 10px;
        }
      }
    }
    .service-tel{
      position: absolute;
      text-align: center;
      width: 100%;
      left: 0;
      bottom: -31px;
      font-size: 12px;
      color: #949bab;
    }
  }
}
.offcn-live-lineone
{
	display: flex;
	align-items: center;
	font-size: 36px;
	padding-top: 80px;
	font-weight: 600;
	img
	{
		margin-right: 16px;
	}
}
.offcn-live-linetwo
{
	margin-top: 80px;
	font-size: 22px;
}
.offcn-live-client,.offcn-live-download
{
	width: 200px;
	height: 48px;
	font-size: 20px;
	background-color: #ff895f;
	color: white;
	border-width: 0;
	border-radius: 4px;
	margin-top: 24px;
	outline: none;
	cursor: pointer;
	font-weight: 600;
}
.offcn-live-linethree
{
	margin-top: 58px;
	font-size: 22px;
}
.offcn-live-serviceline
{
	position: absolute;
	bottom: 40px;
	font-size: 14px;
	color: #737885;
}
.offcn-live-telephone
{
	color: #ff895f;
}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-launch/launch.vue